import { createContext, useContext } from 'react';

/**
 * Puts a prompt in the open chat's composer, replacing any draft, and focuses it for the person to edit
 * and send. Null where there is no composer to fill (a read-only chat, a story, a test).
 */
export type ComposerPrefill = (prompt: string) => void;

export const ComposerPrefillContext = createContext<ComposerPrefill | null>(null);

export function useComposerPrefill(): ComposerPrefill | null {
  return useContext(ComposerPrefillContext);
}

/**
 * Sends a message in the open chat as the composer's Send does, `invokedSkillIds` included (a `/` skill).
 * Null where the chat cannot take a message now (read-only, a turn running, a closed thread, a story).
 */
export type ChatSend = (content: string, invokedSkillIds?: string[]) => void;

export const ChatSendContext = createContext<ChatSend | null>(null);

export function useChatSend(): ChatSend | null {
  return useContext(ChatSendContext);
}
